<template>
  <div>
    <span v-for="(item, index) in data.text" :key="index">
      <span class="text-box" v-if="item.name === 'text'">{{ item.text }}</span>
      <img class="text-img" v-else :src="item.src" />
    </span>
  </div>
</template>

<script lang="ts">
import { watchEffect, ref } from "../../../../adapter-vue";
const __sfc_main = {};
__sfc_main.props = {
  content: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const data = ref();
  watchEffect(() => {
    data.value = props.content;
  });
  return {
    data
  };
};
export default __sfc_main;
</script>
<style lang="scss" scoped>
.text-img {
  width: 20px;
  height: 20px;
}
.text-box {
  white-space: pre-wrap;
  font-size: inherit;
  word-break: break-word;
  font-size: 14px;
  text-size-adjust: none;
}
</style>
